module.exports = __webpack_public_path__ + "img/working-1-1024x768.98bc9bc9.jpg";